// extracted by mini-css-extract-plugin
export default {"messageText":"formMessage_messageText__JHDAe","messageSuccess":"formMessage_messageSuccess__tcD2j","messageFail":"formMessage_messageFail__Vz9YU"};